import { IErrorResponse } from '@carm/_utils/models';

export interface IPreAuthorizedDebitResponse extends IErrorResponse {
  accountNumber: string;
  effectiveDate: string;
  institutionName: string;
  institutionNumber: string;
  transitNumber: string;
  bankNumber: string;
  maxWithdraw: string;
  PADFutureEffectiveDate?: string;
  PADFutureCancellationDate?: string;
}

// newest model for PAD properties
export interface IPadInfo {
  accountNumber: string;
  effectiveDate: string;
  bankNumber: string;
  maxWithdraw: string;
}

export interface IBankInfoShortResponse extends IErrorResponse {
  type: any; // bankDataWsDTO
}

export interface IPadValidity {
  activePad: boolean;
  isfutureEffectiveDate: boolean;
  isfutureCancellationDate: boolean;
  allowNewPad: boolean;
  showAgreement: boolean;
}

export const mapToPadValidity = (res: IPreAuthorizedDebitResponse) => {
  if (!res) { // new -> can create
    return {
      activePad: true,
      showAgreement: false,
    } as IPadValidity;
  }

  const activePad = res.accountNumber !== undefined && res.accountNumber.trim().length !== 0 ? true : false;
  const isfutureEffectiveDate = res.PADFutureEffectiveDate ?  true : false;
  const isfutureCancellationDate = res.PADFutureCancellationDate ?  true : false;
  return {
  activePad,
  isfutureEffectiveDate,
  isfutureCancellationDate,
  allowNewPad: !activePad && !(isfutureEffectiveDate || isfutureCancellationDate),
  showAgreement: activePad || isfutureEffectiveDate || isfutureCancellationDate,
  } as IPadValidity;
};

export interface IBankInfoResponse extends IErrorResponse {
  bankName: string;
  transitAddress: string;
}
